import {
    ServerActionWidget,
    SPI,
    ActionWidget,
    ActionType,
    ClickResult,
    RuntimeServerAction,
    SubmitValue,
    ActiveRecord,
    Widget,
    GenericFunctionService
} from '@kunlun/dependencies';
import { Modal } from 'ant-design-vue';
import { createVNode, h } from 'vue';
@SPI.ClassFactory(
    ActionWidget.Token({
        actionType: ActionType.Server,
        name: 'uiServer0000000000106001',
        model: 'deli.aries.platform.fund.DeliAriesPlatformCreditFBCreateTransient'
    })
)
export class validateCreditAccountCreation extends ServerActionWidget {
    @Widget.Method()
    private createConfirmVNode = (res: any) => {
        // 直接使用导入的h函数，不需要作为参数传递
        return h(
            'div',
            {
                style: {
                    lineHeight: '1.8',
                    fontSize: '14px'
                }
            },
            [
                h('div', res?.blackReason || ''),
                h('div', '是否需要继续创建？'),
            ]
        );
    };

    @Widget.Reactive()
    protected async executeAction(action: RuntimeServerAction, submitValue: SubmitValue): Promise<ClickResult> {
        try {
            const formData = submitValue.records! as ActiveRecord;
            delete formData.__draftId;
            const params = formData;

            const res = (await GenericFunctionService.INSTANCE.simpleExecuteByFun(
                this.model.model,
                'createAndVerify',
                params
            )) as any;

            if (res?.blackReason) {
                Modal.confirm({
                    title: '提示',
                    content: this.createConfirmVNode(res), // 不再传递h函数
                    onOk: async () => {
                        await super.executeAction(action, submitValue);
                    }
                });
            } else {
                await super.executeAction(action, submitValue); // 添加await确保执行完成
            }
        } catch (error) {
            console.error('执行创建验证时出错:', error);
        } finally {
            return false;
        }
    }
}

